// extracted by mini-css-extract-plugin
export default {"loader-container":"NewLoader_loader-container__1RL8m","loader":"NewLoader_loader__Iec8v","rotator":"NewLoader_rotator__1f7-J"};